import type { TemplateDto } from '@pb/shared';
import { get, post, query, uploadFile } from './client';

export const getTemplate = (projectId: number) => get<TemplateDto>(`/projects/${projectId}/template`);
export const uploadTemplateVersion = (
  projectId: number,
  file: File,
  note: string,
  onProgress: (fraction: number) => void,
) => uploadFile<unknown>(`/projects/${projectId}/template${query({ note: note.trim() || undefined })}`, file, onProgress);
export const copyTemplate = (projectId: number, targetProjectId: number) =>
  post<unknown>(`/projects/${projectId}/template/copy`, { target_project_id: targetProjectId });
export const templateVersionFileUrl = (id: number) => `/api/template-versions/${id}/file`;
